module.exports = __webpack_public_path__ + "static/media/T12_headboard Finishing_Eco Nabuk_DK Brown.e4ed8d6d.png";